"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import CustomView from "../custom-view";
import { SlotContainer } from "./slot-container";
import { SlotVisitProps } from "./types";

// SlotVisit Component
export function SlotVisit(t0) {
  const $ = _c(27);
  let className;
  let counterSlots;
  let locality;
  let onChange;
  let onClick;
  let prefill;
  let projectId;
  let props;
  let selectCallback;
  let unitId;
  let userId;
  let viewCounts;
  if ($[0] !== t0) {
    ({
      onChange,
      unitId,
      onClick,
      userId,
      selectCallback,
      projectId,
      prefill,
      counterSlots,
      locality,
      viewCounts,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = counterSlots;
    $[3] = locality;
    $[4] = onChange;
    $[5] = onClick;
    $[6] = prefill;
    $[7] = projectId;
    $[8] = props;
    $[9] = selectCallback;
    $[10] = unitId;
    $[11] = userId;
    $[12] = viewCounts;
  } else {
    className = $[1];
    counterSlots = $[2];
    locality = $[3];
    onChange = $[4];
    onClick = $[5];
    prefill = $[6];
    projectId = $[7];
    props = $[8];
    selectCallback = $[9];
    unitId = $[10];
    userId = $[11];
    viewCounts = $[12];
  }
  let t1;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      views: {
        customWeek: CustomView
      }
    };
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  const {
    views
  } = t1;
  const t2 = unitId || "";
  let t3;
  if ($[14] !== className || $[15] !== counterSlots || $[16] !== locality || $[17] !== onChange || $[18] !== onClick || $[19] !== prefill || $[20] !== projectId || $[21] !== props || $[22] !== selectCallback || $[23] !== t2 || $[24] !== userId || $[25] !== viewCounts) {
    t3 = <SlotContainer locality={locality} onChange={onChange} onClick={onClick} prefill={prefill} counterSlots={counterSlots} projectId={projectId} selectCallback={selectCallback} unitId={t2} userId={userId} viewCounts={viewCounts} views={views} defaultView="customWeek" className={className} {...props} />;
    $[14] = className;
    $[15] = counterSlots;
    $[16] = locality;
    $[17] = onChange;
    $[18] = onClick;
    $[19] = prefill;
    $[20] = projectId;
    $[21] = props;
    $[22] = selectCallback;
    $[23] = t2;
    $[24] = userId;
    $[25] = viewCounts;
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  return t3;
}